import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPerformanceComponent } from "./med-icon-performance.component";

@NgModule({
  declarations: [
    MedIconPerformanceComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPerformanceComponent,
  ],
})
export class MedIconPerformanceModule { }
